import { render, staticRenderFns } from "./block-footer.vue?vue&type=template&id=748d4759&scoped=true"
import script from "./block-footer.vue?vue&type=script&lang=js"
export * from "./block-footer.vue?vue&type=script&lang=js"
import style0 from "./block-footer.vue?vue&type=style&index=0&id=748d4759&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748d4759",
  null
  
)

export default component.exports